import {
  OWN_FOLLOWINGS,
  ADD_NEW_FOLLOWING,
  DELETE_FOLLOWING,
} from "../actions/social";
import logger from 'src/utils/logger/logger';

const initialState = {
  ownFollowings: null,
};

export const addOwnFollowings = (followings) => ({type: OWN_FOLLOWINGS, followings});
export const addNewFollowing = (id) => ({type: ADD_NEW_FOLLOWING, id});
export const deleteFollowing = (id) => ({type: DELETE_FOLLOWING, id});

export const addOwnFollowingsToState = (followings) => dispatch => {
  dispatch(addOwnFollowings(followings))
};

export const incOwnFollowings = (id) => dispatch => {
  logger.debug('id incOwnFollowings', id)
  dispatch(addNewFollowing(id));
};

export const decOwnFollowings = (id) => dispatch => {
  logger.debug('id decOwnFollowings', id)
  dispatch(deleteFollowing(id));
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case OWN_FOLLOWINGS:
      return Object.assign({}, state, { ownFollowings: action.followings });
    case ADD_NEW_FOLLOWING:
      let ownFollowings = Object.assign([], state.ownFollowings);
      ownFollowings.push({ id : action.id })
      return {...state, ownFollowings: ownFollowings };

    case DELETE_FOLLOWING:
      let value = action.id;
      let g = Object.assign([], state.ownFollowings);
      g = g.filter(function(item) {
        return item.id !== value
      })

      return {...state, ownFollowings: g };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/social.js